import Vue from "vue";
import Vuex from "vuex";
import storePublisherPlugin from "./plugins";
import state from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [storePublisherPlugin],
  state,
  mutations,
  actions,
  getters
});
